// Shared notification routing, grouping and labelling helpers.

export function notifLink(n, user) {
  const d = n.data || {};
  switch (n.type) {
    case "favorite":
      // Redirect to the public profile of the user who favorited the item.
      return d.actor_id ? `/user/${d.actor_id}` : (d.listing_id ? `/listing/${d.listing_id}` : null);
    case "favorite_offer": case "price_drop": case "similar": case "tracking_added":
    case "product_sold": case "review_reminder": case "sale_completed":
      return d.listing_id ? `/listing/${d.listing_id}` : null;
    case "order_placed": case "order_shipped": case "order_delivered":
    case "order_completed": case "dispute_resolved":
      return d.order_id ? `/orders?focus=${d.order_id}` : "/orders";
    case "dispute_opened":
      return user?.role === "admin" ? "/admin" : (d.order_id ? `/orders?focus=${d.order_id}` : "/orders");
    case "message": case "offer": case "swap": case "offer_response": case "swap_response":
      return d.conversation_id ? `/messages?conv=${encodeURIComponent(d.conversation_id)}` : "/messages";
    case "security": case "chat_flagged":
      return "/admin";
    case "support": case "support_ticket":
      return d.ticket_id ? `/support?ticket=${d.ticket_id}` : "/support";
    case "review":
      return "/profile";
    case "follow":
      return d.follower_id ? `/user/${d.follower_id}` : "/profile";
    case "wallet_credit": case "wallet_topup": case "withdrawal_completed": case "withdrawal_rejected":
      return "/wallet";
    case "report":
      return "/admin";
    case "listing_removed":
      return "/dashboard";
    case "report_compliant":
      return d.listing_id ? `/listing/${d.listing_id}` : null;
    case "plan_expired": case "plan_activated":
      return "/planes";
    default:
      return null;
  }
}

export const NOTIF_GROUPS = {
  orders: ["order_placed", "order_shipped", "order_delivered", "order_completed", "tracking_added", "sale_completed"],
  disputes: ["dispute_opened", "dispute_resolved"],
  chat: ["message", "offer", "swap", "offer_response", "swap_response"],
  favorites: ["favorite", "favorite_offer", "price_drop", "similar", "product_sold"],
  support: ["support", "support_ticket", "security", "chat_flagged", "report"],
  system: ["review", "review_reminder", "follow", "wallet_credit", "wallet_topup", "withdrawal_completed", "withdrawal_rejected", "listing_removed", "report_compliant", "plan_expired", "plan_activated"],
};

export function notifGroup(n) {
  for (const [g, types] of Object.entries(NOTIF_GROUPS)) {
    if (types.includes(n.type)) return g;
  }
  return "system";
}

export function notifLabel(n, t) {
  const base = t(`notifications.${n.type}`);
  const d = n.data || {};
  if (n.type === "price_drop" && d.new_price != null)
    return `${base} ${d.listing_title}: ${d.old_price} € → ${d.new_price} €`;
  if (n.type === "favorite" && d.nickname)
    return `@${d.nickname} · ${base}${d.listing_title ? " — " + d.listing_title : ""}`;
  if (n.type === "favorite_offer")
    return `${base}${d.amount != null ? ": " + d.amount + " €" : ""}${d.listing_title ? " · " + d.listing_title : ""}`;
  if (n.type === "tracking_added")
    return `${base}${d.listing_title ? " — " + d.listing_title : ""}${d.tracking_number ? ": " + d.tracking_number : ""}`;
  if (n.type === "offer" && d.amount) return `${base}: ${d.amount} €`;
  if (n.type === "follow" && d.follower_name) return `${base}: ${d.follower_name}`;
  if (n.type === "support" && d.subject) return `${base} · ${d.subject}`;
  if (d.listing_title) return `${base} — ${d.listing_title}`;
  if (d.from) return `${base} · ${d.from}`;
  return base;
}
